var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_c('custom-toast',{attrs:{"title":_vm.toastedInfo.title,"message":_vm.toastedInfo.message,"visible":_vm.toastedInfo.visible,"variant":_vm.toastedInfo.variant}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }